import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Safe18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.75 6.35352V4H8.25V6.35352C6.71389 6.78799 5.86536 8.51439 6.4328 9.98795L4.55005 11.4L5.45005 12.6L7.33331 11.1876C8.30542 11.9293 9.69462 11.9293 10.6667 11.1875L12.55 12.6L13.45 11.4L11.5672 9.9879C12.1346 8.51436 11.2861 6.78798 9.75 6.35352ZM9 7.75C8.30964 7.75 7.75 8.30964 7.75 9C7.75 9.69036 8.30964 10.25 9 10.25C9.69036 10.25 10.25 9.69036 10.25 9C10.25 8.30964 9.69036 7.75 9 7.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.5 1.25C1.80964 1.25 1.25 1.80964 1.25 2.5V15.5C1.25 16.1904 1.80964 16.75 2.5 16.75H15.5C16.1904 16.75 16.75 16.1904 16.75 15.5V2.5C16.75 1.80964 16.1904 1.25 15.5 1.25H2.5ZM2.75 15.25V2.75H15.25V15.25H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Safe18.displayName = 'Safe18';
export default Safe18;
